/**
 * What the screens of web and app compute from the club's active notices
 * (`DataSource.listNotices`, already active-only and ordered by the API and
 * the demo store): the notices of one aircraft, and the mark on its fleet card.
 */
import { NOTICE_LEVEL_RANK, type NoticeLevel } from '@fsv/core';
import type { AircraftNotice } from '../data/types';

/** The notices of one aircraft, in the order they came (most urgent first). */
export function noticesOfAircraft(notices: readonly AircraftNotice[] | undefined, aircraftId: string): AircraftNotice[] {
  return (notices ?? []).filter((n) => n.aircraftId === aircraftId);
}

export interface NoticeMark {
  count: number;
  highest: NoticeLevel;
  /** The title of the first grounding, for „Flugzeug gesperrt: …“. */
  groundedBy: string | null;
}

/** The fleet card's mark: how many, how urgent; null without notices. */
export function noticeMark(notices: readonly AircraftNotice[] | undefined, aircraftId: string): NoticeMark | null {
  const own = noticesOfAircraft(notices, aircraftId);
  if (own.length === 0) return null;
  let highest: NoticeLevel = own[0]!.level;
  for (const n of own) if (NOTICE_LEVEL_RANK[n.level] > NOTICE_LEVEL_RANK[highest]) highest = n.level;
  return { count: own.length, highest, groundedBy: own.find((n) => n.level === 'gesperrt')?.title ?? null };
}

/** YYYY-MM-DD → 31.10.2026 (a calendar day, no time zone involved). */
export function formatNoticeDay(day: string): string {
  const [y, m, d] = day.split('-');
  return y && m && d ? `${d}.${m}.${y}` : day;
}
